/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DraftsInputs */

const en_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts`)
};

const es_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borradores`)
};

const fr_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillons`)
};

const de_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwürfe`)
};

const ja_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き`)
};

const zh_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿箱`)
};

const ar_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسودات`)
};

const id_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf`)
};

const it_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozze`)
};

const ru_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновики`)
};

const pt_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunhos`)
};

const ko_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임시저장`)
};

/**
* | output |
* | --- |
* | "Drafts" |
*
* @param {DraftsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drafts = /** @type {((inputs?: DraftsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DraftsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drafts(inputs)
	if (locale === "es") return es_drafts(inputs)
	if (locale === "fr") return fr_drafts(inputs)
	if (locale === "de") return de_drafts(inputs)
	if (locale === "ja") return ja_drafts(inputs)
	if (locale === "zh") return zh_drafts(inputs)
	if (locale === "ar") return ar_drafts(inputs)
	if (locale === "id") return id_drafts(inputs)
	if (locale === "it") return it_drafts(inputs)
	if (locale === "ru") return ru_drafts(inputs)
	if (locale === "pt") return pt_drafts(inputs)
	return ko_drafts(inputs)
});